import {Box, Button, IconButton, Popover, Skeleton, Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import ArrowBackIcon from '@icons/ArrowBackIcon';
import MoreVertIcon from '@icons/MoreVertIcon';
import IChannel from './IChannel';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import LogoutIcon from '@icons/LogoutIcon';
import socket, {IResponse} from '@sockets';

interface IProps {
	channel?: IChannel;
}

export default function ChannelHeader({channel}: IProps) {
	const {t} = useTranslation();
	const navigate = useNavigate();
	const handleBackClicked = () => {
		navigate(-1);
	};
	
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	
	const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	
	const handleClose = () => {
		setAnchorEl(null);
	};
	
	const open = Boolean(anchorEl);
	
	const handleUnmembership = () => {
		handleClose();
		if (channel) {
			if (channel.isMember) {
				socket.emit('network:leave_channel', channel.id, (data: IResponse<boolean>) => {
					if (data.success) {
						channel.isMember = false;
					} else {
						// TODO show error snack
					}
				});
			} else {
				socket.emit('network:join_channel', channel.id, (data: IResponse<IChannel>) => {
					if (data.success) {
						channel.isMember = true;
					} else {
						// TODO show error snack
					}
				});
			}
		}
	};
	
	
	return (
		<Stack className="px-2 h-16 border-b-2"
		       sx={{borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.50' : 'background.default'}}
		       direction="row" spacing={1} alignItems="center">
			<IconButton onClick={handleBackClicked}>
				<ArrowBackIcon/>
			</IconButton>
			{
				channel ?
					<>
						<img className="w-10 h-10 rounded-full" alt="" src={channel.image}/>
						<Typography sx={{
							color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100',
							fontSize: (theme) => theme.typography.fontSize + 6
						}}
						            className="font-medium grow overflow-hidden whitespace-nowrap overflow-ellipsis">{channel.name}</Typography>
					
					</>
					:
					<>
						<Skeleton variant="circular" className="w-10 h-10"/>
						<div className="grow"><Skeleton className="w-1/2"/></div>
					</>
			}
			<IconButton onClick={handleOpen}>
				<MoreVertIcon/>
			</IconButton>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left'
				}}
			>
				<Box className="flex flex-col items-center p-1">
					<Button sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200'}}
					        onClick={handleUnmembership} startIcon={channel?.isMember ?
						<LogoutIcon/> : undefined}>{t(channel?.isMember ? 'un_membership' : 'membership')}</Button>
				</Box>
			</Popover>
		</Stack>
	);
}
